import clsx from 'clsx';
import React, { type ReactNode } from 'react';

import styles from './TariffButton.css';

export interface TariffButtonProps {
    onClick?: () => void;
    className?: string;
    text?: ReactNode;
    subtext?: ReactNode;
}

export function TariffButton({ onClick, className, text, subtext }: TariffButtonProps) {
    return (
        <button className={clsx(styles.root, className)} onClick={onClick}>
            <div className={styles.text}>{text}</div>
            <span className={styles.subtext}>{subtext}</span>
        </button>
    );
}
